/**
 * Component is used to show or hide the content based on the property in the redux store.
 * Attribute [hidden] could be used to override the visibility from outside of the component:
 * for example in the case of smartedit mode components are forced to be visible with css styles.
 *
 * @attr {string} name - Define the property name in the store that should be true to show the content
 * @attr {string} equal-to - Define the property that if the field value equals this value, the slot is visible
 * @attr {boolean} not - Invert the component behaviour so the content is hidden when the 'name' is true
 * @attr {boolean} hidden - Reflect the current state of the component
 *
 * HTML Structure Example
 *
 * <e2-is-visible name="cart.isEmpty">
 *     <!-- CONTENT HERE -->
 * </e2-is-visible>
 */

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { getValueByStorePath } from '@elab/core/utils/helpers';

export class IsVisible extends SimpleLitElement {
    static get properties() {
        return {
            name: { type: String },
            fieldValue: { type: String },
            equalTo: { type: String, attribute: 'equal-to' },
            not: { type: Boolean },
            hidden: { type: Boolean, reflect: true },
        };
    }

    constructor() {
        super();
        this.hidden = false;
        this.fieldValue = '';
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('fieldValue')) {
            const isVisible = this.equalTo ? this.fieldValue === this.equalTo : this.fieldValue;
            this.hidden = this.not ? isVisible : !isVisible;
        }
    }
}

const mapStateToProps = (state, ctx) => ({
    fieldValue: getValueByStorePath(ctx.name, state) || '',
});

export default () => customElements.define('e2-is-visible', connect(mapStateToProps)(IsVisible));
